// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { Box, Container, Typography, Button, Paper, TextField, FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Menu, Snackbar, Alert } from "@mui/material";
// import CancelIcon from '@mui/icons-material/Cancel';
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import WarningIcon from '@mui/icons-material/Warning';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
// import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded';
// import axios from "axios";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

// // Base URL for the backend API
// const path = `http://192.168.1.248:3109`;

// // SearchForm component adapted from GenerateKey.jsx for search functionality
// const SearchForm = ({ mode, loggedInUser, companyData }) => {
//     const [searchText, setSearchText] = useState("");
//     const [searchResults, setSearchResults] = useState([]);
//     const [showResults, setShowResults] = useState(false);
//     const [normalDropdown, setNormalDropdown] = useState("CompanyName");
//     const [page, setPage] = useState(1);
//     const [hasMore, setHasMore] = useState(true);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();
//     const [openExtendDialog, setOpenExtendDialog] = useState(false);
//     const [openUpdateCompanyDialog, setOpenUpdateCompanyDialog] = useState(false);
//     const [selectedRecord, setSelectedRecord] = useState(null);
//     const [formData, setFormData] = useState({ Id: "", DistributorName: "", CompanyName: "", ItemCode: "", ContactPerson: "", MobileNo: "", EmailId: "", Website: "", Address1: "", PinCode: "", Area: "", City: "", State: "", Country: "", ProductKey: "", WAKey: "", ExpiryDate: "", ExpiryDays: "" });
//     const [extendedDate, setExtendedDate] = useState("");
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [menuRecord, setMenuRecord] = useState(null);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const observer = useRef();
//     const [extendDays, setExtendDays] = useState(2); // New state for extend days, default 2

//     // ---------------- lastRecordElementRef ----------------
//     const lastRecordElementRef = useCallback(
//         (node) => {
//             if (loading) return;
//             if (observer.current) observer.current.disconnect();
//             observer.current = new IntersectionObserver((entries) => {
//                 if (entries[0].isIntersecting && hasMore && !loading) {
//                     setPage((prev) => prev + 1);
//                 }
//             }, { rootMargin: '200px' }); // small prefetch
//             if (node) observer.current.observe(node);
//         },
//         [loading, hasMore]
//     );

//     // ---------------- handleSearch ----------------
//     const handleSearch = async (q, pageNum = 1) => {
//         setSearchText(q);

//         const pageSizeNum = 50; // must match the API call
//         if (!q || !q.toString().trim()) {
//             // clear UI state
//             setSearchResults([]);
//             setShowResults(false);
//             setPage(1);
//             setHasMore(true);
//             setTotalRecords(0);
//             return;
//         }

//         setLoading(true);
//         try {
//             const resp = await axios.get(`${path}/api/members/search`, { params: { [normalDropdown]: q, page: pageNum, pageSize: pageSizeNum } });

//             console.log(resp.data);

//             const { rows = [], total = null } = resp.data || {};

//             // update results safely using functional setState
//             setSearchResults((prev) => {
//                 const newList = pageNum === 1 ? rows : [...prev, ...rows];

//                 // decide hasMore:
//                 if (typeof total === 'number') {
//                     // stop when we've fetched all rows
//                     setHasMore(newList.length < total);
//                 } else {
//                     // fallback: assume more if we received a full page
//                     setHasMore(rows.length === pageSizeNum);
//                 }

//                 return newList;
//             });

//             setShowResults(true);
//             setTotalRecords(typeof total === 'number' ? total : (prev => prev)); // will set below
//             // ensure totalRecords state gets correct value (if server returned it)
//             if (typeof total === 'number') setTotalRecords(total);

//         } catch (error) {
//             console.error('Search error:', error);
//             // preserve old results on load-more failure; clear on first page
//             setSearchResults((prev) => (pageNum === 1 ? [] : prev));
//             setShowResults(true);
//             setHasMore(false);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ---------------- effect: load more when page changes ----------------
//     useEffect(() => {
//         // only fetch when page > 1 (initial load handled by debounce)
//         if (page > 1 && searchText && searchText.toString().trim()) {
//             handleSearch(searchText, page);
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [page]); // only depend on page (normalDropdown handled separately below)

//     // ---- debounce effect (keep but ensure it resets page and calls page 1) ----
//     useEffect(() => {
//         const timeout = setTimeout(() => {
//             if (searchText && searchText.toString().trim()) {
//                 setPage(1); // reset to first page for new search
//                 handleSearch(searchText, 1);
//             } else {
//                 setSearchResults([]);
//                 setShowResults(false);
//                 setHasMore(true);
//                 setTotalRecords(0);
//             }
//         }, 500);
//         return () => clearTimeout(timeout);
//     }, [searchText, normalDropdown]);

//     // Handle Update button click to navigate to GenerateKey with Id
//     const handleUpdateClick = (r) => {
//         navigate("/main/generate-key", { state: { mode: "update", Id: r.Id } });
//         setAnchorEl(null);
//     };

//     // Handle Extend button click to open dialog with pre-filled data
//     const handleExtendClick = (r) => {
//         setSelectedRecord(r);
//         setFormData({
//             Id: r.Id || "",
//             DistributorName: r.DistributorName || "",
//             CompanyName: r.CompanyName || "",
//             ItemCode: r.ItemCode || "",
//             ContactPerson: r.ContactPerson || "",
//             MobileNo: r.MobileNo || "",
//             EmailId: r.EmailId || "",
//             Website: r.Website || "",
//             Address1: r.Address1 || "",
//             PinCode: r.PinCode || "",
//             Area: r.Area || "",
//             City: r.City || "",
//             State: r.State || "",
//             Country: r.Country || "",
//             ProductKey: r.ProductKey || "",
//             WAKey: r.WAKey || "",
//             ExpiryDate: r.ExpiryDate || "",
//             ExpiryDays: ""
//         });
//         setExtendedDate(""); // Reset extended date when opening dialog
//         setOpenExtendDialog(true);
//         setAnchorEl(null);
//     };

//     // Handle Update Company Data click to open dialog with pre-filled data
//     const handleUpdateCompanyClick = (r) => {
//         setSelectedRecord(r);
//         setFormData({
//             Id: r.Id || "", // Ensure Id is included
//             DistributorName: r.DistributorName || "",
//             CompanyName: r.CompanyName || "",
//             ItemCode: r.ItemCode || "",
//             ContactPerson: r.ContactPerson || "",
//             MobileNo: r.MobileNo || "",
//             EmailId: r.EmailId || "",
//             Website: r.Website || "",
//             Address1: r.Address1 || "",
//             PinCode: r.PinCode || "",
//             Area: r.Area || "",
//             City: r.City || "",
//             State: r.State || "",
//             Country: r.Country || "",
//             ProductKey: r.ProductKey || "",
//             WAKey: r.WAKey || "",
//             ExpiryDate: r.ExpiryDate || "",
//             ExpiryDays: ""
//         });
//         setOpenUpdateCompanyDialog(true);
//         setAnchorEl(null);
//     };

//     // Handle form field changes in the dialog
//     const handleFormChange = (field, value) => { setFormData((prev) => ({ ...prev, [field]: value })); };

//     // Fetch expiry days when ExpiryDate changes
//     useEffect(() => {
//         if (formData.ExpiryDate) {
//             const expiryDate = new Date(formData.ExpiryDate);
//             const today = new Date();
//             today.setHours(0, 0, 0, 0); // Normalize to midnight for comparison
//             expiryDate.setHours(0, 0, 0, 0);
//             const diffTime = expiryDate - today;
//             const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//             let displayDays;
//             if (diffDays < 0) {
//                 displayDays = `-(${Math.abs(diffDays)})`;
//             } else if (diffDays === 0) {
//                 displayDays = "0";
//             } else {
//                 displayDays = `${diffDays}`;
//             }
//             setFormData((prev) => ({ ...prev, ExpiryDays: displayDays }));
//         }
//     }, [formData.ExpiryDate]);

//     // Handle Extend button click in dialog
//     const handleExtendDialogSubmit = async () => {
//         console.log(formData);
//         if (formData.ExpiryDate) {
//             const today = new Date();
//             today.setHours(0, 0, 0, 0);
//             const expiryDate = new Date(formData.ExpiryDate);
//             expiryDate.setHours(0, 0, 0, 0);
//             let newExpiryDate;
//             if (expiryDate <= today) {
//                 newExpiryDate = new Date(today);
//                 newExpiryDate.setDate(today.getDate() + extendDays);
//             } else {
//                 newExpiryDate = new Date(expiryDate);
//                 newExpiryDate.setDate(expiryDate.getDate() + extendDays);
//             }
//             // Format date to YYYY-MM-DD
//             const formattedDate = newExpiryDate.toISOString().split('T')[0];

//             // store to state so UI shows it
//             setExtendedDate(formattedDate);

//             // Update ExpiryDays based on new date
//             const diffTimeNew = newExpiryDate - today;
//             const diffDaysNew = Math.ceil(diffTimeNew / (1000 * 60 * 60 * 24));
//             let displayDaysNew;
//             if (diffDaysNew < 0) {
//                 displayDaysNew = `-${Math.abs(diffDaysNew)}`;
//             } else if (diffDaysNew === 0) {
//                 displayDaysNew = "0";
//             } else {
//                 displayDaysNew = `${diffDaysNew}`;
//             }
//             setFormData((prev) => ({ ...prev, ExpiryDays: displayDaysNew }));

//             // Validate required fields
//             const missingFields = [];
//             if (!formData.Id) missingFields.push("Id");
//             if (!formData.ProductKey) missingFields.push("ProductKey");
//             if (!formattedDate) missingFields.push("ExpiryDate");
//             if (missingFields.length > 0) {
//                 console.log("Missing fields:", missingFields);
//                 setSnackbar({
//                     open: true,
//                     message: `Missing required fields: ${missingFields.join(", ")}`,
//                     severity: "error"
//                 });
//                 return;
//             }

//             // Create payload for API call
//             const payload = {
//                 Id: formData.Id,
//                 CustomerId: formData.CustomerId,
//                 ProductKey: formData.ProductKey,
//                 ExpiryDate: formattedDate,
//                 ExtendedDate: formattedDate,
//                 ExpiryDays: displayDaysNew
//             };
//             console.log(payload);
//             try {
//                 const response = await axios.post(`${path}/api/members/extend`, payload);
//                 console.log("Extend key response:", response.data);
//                 setSnackbar({ open: true, message: "Key extended successfully", severity: "success" });
//             } catch (error) {
//                 console.error("Error extending key:", error.response?.data || error.message);
//                 setSnackbar({ open: true, message: "Failed to extend key", severity: "error" });
//             }
//         } else {
//             setSnackbar({ open: true, message: "Expiry Date is required", severity: "error" });
//         }
//     };

//     // Handle Update Company dialog submission
//     const handleUpdateCompanyDialogSubmit = async () => {
//         // Log formData for debugging
//         console.log("formData:", formData);

//         // Validate Id
//         if (!formData.Id) {
//             setSnackbar({ open: true, message: "Record ID is missing", severity: "error" });
//             return;
//         }

//         // Create payload for updating company data
//         const payload = {
//             Id: formData.Id,
//             DistributorName: formData.DistributorName,
//             CompanyName: formData.CompanyName,
//             ItemCode: formData.ItemCode,
//             ContactPerson: formData.ContactPerson,
//             MobileNo: formData.MobileNo,
//             EmailId: formData.EmailId,
//             Website: formData.Website,
//             Address1: formData.Address1,
//             PinCode: formData.PinCode,
//             Area: formData.Area,
//             City: formData.City,
//             State: formData.State,
//             Country: formData.Country
//         };

//         // Log the payload
//         console.log("Update company data payload:", payload);

//         try {
//             // Send payload to backend
//             const response = await axios.post(`${path}/api/members/updateCompany`, payload);
//             console.log("Update company data response:", response.data);
//             setSnackbar({ open: true, message: "Company data updated successfully", severity: "success" });
//             setOpenUpdateCompanyDialog(false);
//             setSelectedRecord(null);
//         } catch (error) {
//             console.error("Error updating company data:", error.response?.data || error.message);
//             setSnackbar({ open: true, message: "Failed to update company data", severity: "error" });
//         }
//     };

//     // Handle dialog close
//     const handleDialogClose = (dialogType) => {
//         if (dialogType === "extend") {
//             setOpenExtendDialog(false);
//             setExtendedDate(""); // Reset extended date on close
//         } else {
//             setOpenUpdateCompanyDialog(false);
//         }
//         setSelectedRecord(null);
//     };

//     // Handle three-dot menu open
//     const handleMenuOpen = (event, record) => {
//         setAnchorEl(event.currentTarget);
//         setMenuRecord(record);
//     };

//     // Handle three-dot menu close
//     const handleMenuClose = () => {
//         setAnchorEl(null);
//         setMenuRecord(null);
//     };

//     // Determine warning icon based on expiry date
//     const getWarningIcon = () => {
//         if (!formData.ExpiryDate) return null;
//         const expiryDate = new Date(formData.ExpiryDate);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         expiryDate.setHours(0, 0, 0, 0);
//         if (expiryDate < today) {
//             return <WarningIcon sx={{ color: "#d32f2f" }} />;
//         } else if (expiryDate.getTime() === today.getTime()) {
//             return <WarningIcon sx={{ color: "#fbc02d" }} />;
//         } else if (expiryDate > today) {
//             return <CheckCircleIcon sx={{ color: "#4caf50" }} />;
//         }
//         return null;
//     };

//     // Add inside SearchForm component (with access to menuRecord, setAnchorEl, setSnackbar, setMenuRecord)
//     const handleCancelWhatsapp = async (record) => {
//         // close menu immediately
//         setAnchorEl(null);
//         setMenuRecord(null);

//         if (!record) {
//             setSnackbar({ open: true, message: "No record selected", severity: "error" });
//             return;
//         }

//         // Try to read CustomerId with both casings
//         const CustomerId = record.CustomerId ?? record.CustomerID ?? record.CustomerIdString ?? "";

//         const payload = {
//             Id: record.Id,
//             CustomerId,         // may be empty string; backend will fetch if needed
//             ProductKey: record.ProductKey,
//             Deactivate: 1
//         };

//         try {
//             const resp = await axios.post(`${path}/api/members/cancelWhatsapp`, payload);
//             console.log("cancelWhatsapp resp:", resp.data);
//             if (resp.data && resp.data.success) {
//                 // update searchResults: set WAKey to empty string for this record
//                 setSearchResults((prev) =>
//                     prev.map((r) => {
//                         // match by Id and ProductKey (both should uniquely identify)
//                         if (r.Id === record.Id && (r.ProductKey ?? "") === (record.ProductKey ?? "")) {
//                             return { ...r, WAKey: "", WAApplied: 0 };
//                         }
//                         return r;
//                     })
//                 );

//                 // if the extend/update dialog is open for this record, update selectedRecord and formData too
//                 if (selectedRecord && selectedRecord.Id === record.Id && (selectedRecord.ProductKey ?? "") === (record.ProductKey ?? "")) {
//                     setSelectedRecord((prev) => ({ ...prev, WAKey: "", WAApplied: 0 }));
//                     setFormData((prev) => ({ ...prev, WAKey: "", WAApplied: 0 }));
//                 }

//                 setSnackbar({ open: true, message: resp.data.message || "WhatsApp cancelled", severity: "success" });
//             } else {
//                 setSnackbar({ open: true, message: resp.data.message || "Failed to cancel WhatsApp", severity: "error" });
//             }
//         } catch (err) {
//             console.error("cancelWhatsapp error:", err.response?.data || err.message);
//             setSnackbar({ open: true, message: "Failed to cancel WhatsApp", severity: "error" });
//         }
//     };

//     // Helper function to format date to dd-mm-yyyy
//     const formatDate = (dateString) => {
//         if (!dateString) return "N/A";
//         const date = new Date(dateString);
//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//         const year = date.getFullYear();
//         return `${day}-${month}-${year}`;
//     };

//     return (
//         <Box sx={{ pb: 2, px: 1 }}>
//             <Box sx={{ mb: 2, position: "relative" }}>
//                 <Box sx={{ mb: 2 }}>
//                     <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: 2, width: "100%" }}>
//                         {/* Left: Gen. New Key Button */}
//                         <Button variant="contained" onClick={() => navigate("/main/generate-key", { state: { mode: "New" } })}
//                             sx={{ height: 40, bgcolor: "#1877F2", "&:hover": { bgcolor: "#145db5" }, borderRadius: 2, textTransform: "none", fontWeight: "medium", px: 2, display: "flex", alignItems: "center", justifyContent: "center", }}
//                         >
//                             <span style={{ display: "flex", alignItems: "center", gap: "8px", margin: "0 20px" }} >
//                                 New <VpnKeyRoundedIcon />
//                             </span>
//                         </Button>
//                         {/* Center: Search Form */}
//                         <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: { xs: 1, sm: 2 }, alignItems: { xs: "stretch", sm: "center" }, flexGrow: 1, maxWidth: { xs: "100%", sm: "650px", md: "950px" } }}>
//                             <FormControl sx={{ width: { xs: "100%", sm: 250, md: 300 }, "& .MuiOutlinedInput-root": { height: 40, borderRadius: 2, "& .MuiSelect-select": { display: "flex", alignItems: "center", height: "100%" } } }}>
//                                 <InputLabel id="search-by-label">Search By</InputLabel>
//                                 <Select labelId="search-by-label" value={normalDropdown} label="Search By" onChange={(e) => setNormalDropdown(e.target.value)}>
//                                     <MenuItem value="CompanyName">Company Name</MenuItem>
//                                     <MenuItem value="MobileNo">Mobile Number</MenuItem>
//                                     <MenuItem value="ProductKey">Product Key</MenuItem>
//                                 </Select>
//                             </FormControl>
//                             <TextField label="Search" size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)}
//                                 sx={{
//                                     width: { xs: "100%", sm: 400, md: 650 },
//                                     "& .MuiInputBase-root": { height: 40, borderRadius: 2, backgroundColor: "#F5F7FA", "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" } } },
//                                     "& .MuiInputLabel-root": { fontSize: "0.85rem", color: "#555", "&.Mui-focused": { color: "#1976D2" } },
//                                     "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" }
//                                 }}
//                             />
//                         </Box>
//                         {/* Right: Upload Button */}
//                         <Button variant="contained" color="warning" onClick={() => navigate("/main/FileUpload")} sx={{ height: 40, borderRadius: 8, textTransform: "none", fontWeight: "medium" }} >
//                             <DriveFolderUploadIcon />
//                         </Button>
//                         {/* CHANGE: Added Insert Data Button */}
//                         <Button variant="contained" color="primary" onClick={() => navigate("/main/InsertData")} sx={{ height: 40, borderRadius: 3 }} >
//                             <InsertDriveFileIcon />
//                         </Button>
//                     </Box>
//                 </Box>
//                 {/* Search results dropdown */}
//                 {showResults && searchText && (
//                     <Paper sx={{ position: "absolute", mt: 0, maxHeight: "82vh", overflowY: "auto", zIndex: 10, borderRadius: 3, border: "1px solid #e0e0e0", boxShadow: "0 6px 16px rgba(0,0,0,0.1)", backgroundColor: "#fff", transition: "transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out", width: { xs: "100%", sm: "calc(250px + 400px + 16px)", md: "calc(300px + 800px + 16px)", } }} >
//                         {searchResults.length ? (
//                             searchResults.map((r, index) => (
//                                 <Box key={r.CustomerID} ref={index === searchResults.length - 1 ? lastRecordElementRef : null} sx={{ m: 1, p: 1.5, borderRadius: 3, border: "1px solid #e0e0e0", backgroundColor: index % 2 === 0 ? "#ffffff" : "#f0f6ff", transition: "transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out", position: "relative", "&:hover": { transform: "scale(1.001)", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", backgroundColor: index % 2 === 0 ? "#f8fafc" : "#e6f0ff", }, }} >
//                                     <IconButton onClick={(e) => handleMenuOpen(e, r)} sx={{ position: "absolute", top: 8, right: 8, color: "#666", "&:hover": { color: "#1976D2" }, }} >
//                                         <MoreVertIcon />
//                                     </IconButton>
//                                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                                         <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
//                                             <Typography variant="h6" fontWeight="600" color="#1976D2" sx={{ fontSize: "1rem", lineHeight: 1 }} >
//                                                 {r.CompanyName || "N/A"}
//                                             </Typography>
//                                         </Box>
//                                         <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 0.5, }} >
//                                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}> <strong>Product Key:</strong> {r.ProductKey || "N/A"} </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}> <strong>Contact Person:</strong> {r.ContactPerson || "N/A"} </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}> <strong>Mobile Number:</strong> {r.MobileNo || "N/A"} </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}> <strong>Email:</strong> {r.EmailId || "N/A"} </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}> <strong>Location:</strong> {r.City || "N/A"}, {r.State || "N/A"} </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
//                                                 <strong>WAKey:</strong> {(r.WAKey === null || typeof r.WAKey === "undefined") ? "-" : r.WAKey}
//                                             </Typography>
//                                         </Box>
//                                     </Box>
//                                 </Box>
//                             ))
//                         ) : (
//                             <Typography sx={{ p: 2, textAlign: "center", color: "#666", fontSize: "0.9rem" }}> No Data Available </Typography>
//                         )}
//                     </Paper>
//                 )}
//             </Box>

//             {/* Three-dot menu */}
//             <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} anchorOrigin={{ vertical: 'top', horizontal: 'left', }} transformOrigin={{ vertical: 'top', horizontal: 'right', }} sx={{ "& .MuiPaper-root": { borderRadius: 2, boxShadow: "0 4px 12px rgba(0,0,0,0.15)", minWidth: 180, } }} >
//                 <MenuItem onClick={() => handleUpdateClick(menuRecord)} sx={{ fontSize: "0.9rem" }}> Update </MenuItem>
//                 <MenuItem onClick={() => handleExtendClick(menuRecord)} sx={{ fontSize: "0.9rem" }}> Extend </MenuItem>
//                 <MenuItem onClick={() => handleUpdateCompanyClick(menuRecord)} sx={{ fontSize: "0.9rem" }}> Update Company Data </MenuItem>
//                 <MenuItem onClick={() => handleCancelWhatsapp(menuRecord)}> Cancel WhatsApp </MenuItem>
//             </Menu>

//             {/* Dialog for Extend mode */}
//             <Dialog open={openExtendDialog} onClose={() => handleDialogClose("extend")} maxWidth="md" fullWidth sx={{ "& .MuiDialog-paper": { borderRadius: 3, boxShadow: "0 8px 24px rgba(0,0,0,0.2)", backgroundColor: "#f9fafb", p: 2, maxHeight: "80vh", overflowY: "auto" } }} >
//                 <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem", color: "#1976D2", display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1, borderBottom: "1px solid #e0e0e0" }}>
//                     Extend Key
//                     <Button onClick={() => handleDialogClose("extend")} sx={{ minWidth: 0, p: 0.5, color: "#666", "&:hover": { color: "#d32f2f" } }} >
//                         <CancelIcon />
//                     </Button>
//                 </DialogTitle>
//                 <DialogContent sx={{ p: 3 }}>
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 2 }}>
//                         <Typography variant="h6" fontWeight="600" color="#1976D2" sx={{ fontSize: "1rem", lineHeight: 1 }} >
//                             {formData.CompanyName || "N/A"}
//                         </Typography>
//                         <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 0.5 }}>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Contact Person:</strong> {formData.ContactPerson || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Mobile Number:</strong> {formData.MobileNo || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Email:</strong> {formData.EmailId || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Website:</strong> {formData.Website || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Address:</strong> {formData.Address1 || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Pin Code:</strong> {formData.PinCode || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Area:</strong> {formData.Area || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>City:</strong> {formData.City || "N/A"} </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>State:</strong> {formData.State || "N/A"} </Typography>
//                             <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} > <strong>Country:</strong> {formData.Country || "N/A"} </Typography>
//                             </Box>
//                         </Box>
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} >
//                                 <strong>Expiry Date:</strong> {formatDate(formData.ExpiryDate)}
//                             </Typography>
//                             <TextField
//                                 label="Extend by (days)"
//                                 type="number"
//                                 value={extendDays}
//                                 onChange={(e) => setExtendDays(Math.max(1, parseInt(e.target.value) || 2))} // Integer only, min 1
//                                 inputProps={{ min: 1, step: 1 }}
//                                 size="small"
//                                 sx={{ width: 120 }}
//                             />
//                             {formData.ExpiryDate && (() => {
//                                 const today = new Date();
//                                 today.setHours(0, 0, 0, 0);
//                                 const expiry = new Date(formData.ExpiryDate);
//                                 expiry.setHours(0, 0, 0, 0);
//                                 const diffTime = expiry - today;
//                                 const daysToExpiry = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//                                 return daysToExpiry <= 7 ? (
//                                     <Button variant="contained" onClick={handleExtendDialogSubmit} disabled={!!extendedDate} sx={{ height: 30, bgcolor: "#1976D2", "&:hover": { bgcolor: "#115293" }, borderRadius: 2, textTransform: "none", fontWeight: "medium", px: 2, "&.Mui-disabled": { bgcolor: "#bdbdbd", cursor: "not-allowed", color: "#666" } }} >
//                                         Extend
//                                     </Button>
//                                 ) : null;
//                             })()}
//                             {getWarningIcon()}
//                             {extendedDate && (
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem", marginLeft: 14.4 }} >
//                                     <strong>Extended Date:</strong> {extendedDate}
//                                 </Typography>
//                             )}
//                         </Box>
//                         <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} >
//                             <strong>Expiry Days:</strong> {formData.ExpiryDays || "0"}
//                         </Typography>
//                     </Box>
//                 </DialogContent>
//                 <DialogActions sx={{ p: 2, borderTop: "1px solid #e0e0e0", backgroundColor: "#fff", borderRadius: "0 0 12px 12px", display: "flex", justifyContent: "flex-end", gap: 1 }}>
//                     <Button onClick={() => handleDialogClose("extend")} variant="outlined" sx={{ borderRadius: 2, textTransform: "none", fontWeight: "medium", color: "#666", borderColor: "#e0e0e0", "&:hover": { borderColor: "#d32f2f", color: "#d32f2f" } }} >
//                         Cancel
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Dialog for Update Company Data mode */}
//             <Dialog open={openUpdateCompanyDialog} onClose={() => handleDialogClose("updateCompany")} maxWidth="md" fullWidth sx={{ "& .MuiDialog-paper": { borderRadius: 3, boxShadow: "0 8px 24px rgba(0,0,0,0.2)", backgroundColor: "#f9fafb", p: 2, maxHeight: "80vh", overflowY: "auto" } }} >
//                 <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem", color: "#1976D2", display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1, borderBottom: "1px solid #e0e0e0" }}>
//                     Update Company Data
//                     <Button onClick={() => handleDialogClose("updateCompany")} sx={{ minWidth: 0, p: 0.5, color: "#666", "&:hover": { color: "#d32f2f" } }} >
//                         <CancelIcon />
//                     </Button>
//                 </DialogTitle>
//                 <DialogContent sx={{ p: 3 }}>
//                     <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr" }, gap: 2, mt: 2, }} >
//                         {/* DistributorName full width */}
//                         <TextField key="DistributorName" label="Distributor Name" value={formData["DistributorName"] || ""} onChange={(e) => handleFormChange("DistributorName", e.target.value)} fullWidth size="small" variant="outlined"
//                             sx={{
//                                 "& .MuiInputBase-root": { height: 40, borderRadius: 2, backgroundColor: "#fff", "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" }, }, },
//                                 "& .MuiInputLabel-root": { fontSize: "0.85rem", color: "#555", "&.Mui-focused": { color: "#1976D2" }, },
//                                 "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
//                             }}
//                         />

//                         {/* Two-column grid */}
//                         <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2, }} >
//                             {/* Left column */}
//                             <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//                                 {["CompanyName", "ContactPerson", "EmailId", "Address1", "Area", "State"].map(
//                                     (field) => (
//                                         <TextField key={field} label={field.replace(/([A-Z])/g, " $1").trim()} value={formData[field] || ""} onChange={(e) => handleFormChange(field, e.target.value)} fullWidth size="small" variant="outlined"
//                                             sx={{
//                                                 "& .MuiInputBase-root": { height: 40, borderRadius: 2, backgroundColor: "#fff", "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2", }, }, },
//                                                 "& .MuiInputLabel-root": { fontSize: "0.85rem", color: "#555", "&.Mui-focused": { color: "#1976D2" }, },
//                                                 "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
//                                             }}
//                                         />
//                                     )
//                                 )}
//                             </Box>

//                             {/* Right column */}
//                             <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//                                 {["ItemCode", "MobileNo", "Website", "PinCode", "City", "Country"].map(
//                                     (field) => (
//                                         <TextField key={field} label={field.replace(/([A-Z])/g, " $1").trim()} value={formData[field] || ""} onChange={(e) => handleFormChange(field, e.target.value)} fullWidth size="small" variant="outlined"
//                                             sx={{
//                                                 "& .MuiInputBase-root": { height: 40, borderRadius: 2, backgroundColor: "#fff", "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2", }, }, },
//                                                 "& .MuiInputLabel-root": { fontSize: "0.85rem", color: "#555", "&.Mui-focused": { color: "#1976D2" }, },
//                                                 "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
//                                             }}
//                                         />
//                                     )
//                                 )}
//                             </Box>
//                         </Box>
//                     </Box>
//                 </DialogContent>
//                 <DialogActions sx={{ p: 2, borderTop: "1px solid #e0e0e0", backgroundColor: "#fff", borderRadius: "0 0 12px 12px" }}>
//                     <Button onClick={() => handleDialogClose("updateCompany")} color="error" variant="outlined" sx={{ borderRadius: 2, textTransform: "none", fontWeight: "medium", borderColor: "#e0e0e0", "&:hover": { borderColor: "#d32f2f", } }} >
//                         Cancel
//                     </Button>
//                     <Button onClick={handleUpdateCompanyDialogSubmit} variant="contained" sx={{ borderRadius: 2, textTransform: "none", fontWeight: "medium", bgcolor: "#1976D2", "&:hover": { bgcolor: "#115293" }, px: 3 }} >
//                         Submit
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Snackbar for feedback */}
//             <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
//                 <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// const KeyOptions = () => {
//     return (
//         <Container sx={{ pt: 3 }}>
//             <SearchForm mode="update" />
//         </Container>
//     );
// };

// export default KeyOptions;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Typography, Button, Paper, TextField, FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Menu, Snackbar, Alert } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded';
import axios from "axios";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

// Base URL for the backend API
const path = `http://192.168.1.248:3109`;

// SearchForm component adapted from GenerateKey.jsx for search functionality
const SearchForm = ({ mode, loggedInUser, companyData }) => {
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [normalDropdown, setNormalDropdown] = useState("CompanyName");
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [openExtendDialog, setOpenExtendDialog] = useState(false);
    const [openUpdateCompanyDialog, setOpenUpdateCompanyDialog] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [formData, setFormData] = useState({ Id: "", DistributorName: "", CompanyName: "", ItemCode: "", ContactPerson: "", MobileNo: "", EmailId: "", Website: "", Address1: "", PinCode: "", Area: "", City: "", State: "", Country: "", ProductKey: "", WAKey: "", ExpiryDate: "", ExpiryDays: "" });
    const [extendedDate, setExtendedDate] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuRecord, setMenuRecord] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const observer = useRef();
    const [extendDays, setExtendDays] = useState(2); // New state for extend days, default 2

    // ---------------- lastRecordElementRef ----------------
    const lastRecordElementRef = useCallback(
        (node) => {
            if (loading) return;
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMore && !loading) {
                    setPage((prev) => prev + 1);
                }
            }, { rootMargin: '200px' }); // small prefetch
            if (node) observer.current.observe(node);
        },
        [loading, hasMore]
    );

    // ---------------- handleSearch ----------------
    const handleSearch = async (q, pageNum = 1) => {
        setSearchText(q);

        const pageSizeNum = 50; // must match the API call
        if (!q || !q.toString().trim()) {
            // clear UI state
            setSearchResults([]);
            setShowResults(false);
            setPage(1);
            setHasMore(true);
            setTotalRecords(0);
            return;
        }

        setLoading(true);
        try {
            const resp = await axios.get(`${path}/api/members/search`, { params: { [normalDropdown]: q, page: pageNum, pageSize: pageSizeNum } });

            console.log(resp.data);

            const { rows = [], total = null } = resp.data || {};

            // update results safely using functional setState
            setSearchResults((prev) => {
                const newList = pageNum === 1 ? rows : [...prev, ...rows];

                // decide hasMore:
                if (typeof total === 'number') {
                    // stop when we've fetched all rows
                    setHasMore(newList.length < total);
                } else {
                    // fallback: assume more if we received a full page
                    setHasMore(rows.length === pageSizeNum);
                }

                return newList;
            });

            setShowResults(true);
            setTotalRecords(typeof total === 'number' ? total : (prev => prev)); // will set below
            // ensure totalRecords state gets correct value (if server returned it)
            if (typeof total === 'number') setTotalRecords(total);

        } catch (error) {
            console.error('Search error:', error);
            // preserve old results on load-more failure; clear on first page
            setSearchResults((prev) => (pageNum === 1 ? [] : prev));
            setShowResults(true);
            setHasMore(false);
        } finally {
            setLoading(false);
        }
    };

    // ---------------- effect: load more when page changes ----------------
    useEffect(() => {
        // only fetch when page > 1 (initial load handled by debounce)
        if (page > 1 && searchText && searchText.toString().trim()) {
            handleSearch(searchText, page);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]); // only depend on page (normalDropdown handled separately below)

    // ---- debounce effect (keep but ensure it resets page and calls page 1) ----
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (searchText && searchText.toString().trim()) {
                setPage(1); // reset to first page for new search
                handleSearch(searchText, 1);
            } else {
                setSearchResults([]);
                setShowResults(false);
                setHasMore(true);
                setTotalRecords(0);
            }
        }, 500);
        return () => clearTimeout(timeout);
    }, [searchText, normalDropdown]);

    // Handle Update button click to navigate to GenerateKey with Id
    const handleUpdateClick = (r) => {
        navigate("/main/generate-key", { state: { mode: "update", Id: r.Id } });
        setAnchorEl(null);
    };

    // Handle Extend button click to open dialog with pre-filled data
    const handleExtendClick = (r) => {
        setSelectedRecord(r);
        setFormData({
            Id: r.Id || "",
            DistributorName: r.DistributorName || "",
            CompanyName: r.CompanyName || "",
            ItemCode: r.ItemCode || "",
            ContactPerson: r.ContactPerson || "",
            MobileNo: r.MobileNo || "",
            EmailId: r.EmailId || "",
            Website: r.Website || "",
            Address1: r.Address1 || "",
            PinCode: r.PinCode || "",
            Area: r.Area || "",
            City: r.City || "",
            State: r.State || "",
            Country: r.Country || "",
            ProductKey: r.ProductKey || "",
            WAKey: r.WAKey || "",
            ExpiryDate: r.ExpiryDate || "",
            ExpiryDays: ""
        });
        setExtendedDate(""); // Reset extended date when opening dialog
        setOpenExtendDialog(true);
        setAnchorEl(null);
    };

    // Handle Update Company Data click to open dialog with pre-filled data
    const handleUpdateCompanyClick = (r) => {
        setSelectedRecord(r);
        setFormData({
            Id: r.Id || "", // Ensure Id is included
            DistributorName: r.DistributorName || "",
            CompanyName: r.CompanyName || "",
            ItemCode: r.ItemCode || "",
            ContactPerson: r.ContactPerson || "",
            MobileNo: r.MobileNo || "",
            EmailId: r.EmailId || "",
            Website: r.Website || "",
            Address1: r.Address1 || "",
            PinCode: r.PinCode || "",
            Area: r.Area || "",
            City: r.City || "",
            State: r.State || "",
            Country: r.Country || "",
            ProductKey: r.ProductKey || "",
            WAKey: r.WAKey || "",
            ExpiryDate: r.ExpiryDate || "",
            ExpiryDays: ""
        });
        setOpenUpdateCompanyDialog(true);
        setAnchorEl(null);
    };

    // Handle form field changes in the dialog
    const handleFormChange = (field, value) => { setFormData((prev) => ({ ...prev, [field]: value })); };

    // Fetch expiry days when ExpiryDate changes
    useEffect(() => {
        if (formData.ExpiryDate) {
            const expiryDate = new Date(formData.ExpiryDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Normalize to midnight for comparison
            expiryDate.setHours(0, 0, 0, 0);
            const diffTime = expiryDate - today;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let displayDays;
            if (diffDays < 0) {
                displayDays = `-(${Math.abs(diffDays)})`;
            } else if (diffDays === 0) {
                displayDays = "0";
            } else {
                displayDays = `${diffDays}`;
            }
            setFormData((prev) => ({ ...prev, ExpiryDays: displayDays }));
        }
    }, [formData.ExpiryDate]);

    // Handle Extend button click in dialog
    const handleExtendDialogSubmit = async () => {
        console.log(formData);
        if (formData.ExpiryDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const expiryDate = new Date(formData.ExpiryDate);
            expiryDate.setHours(0, 0, 0, 0);
            let newExpiryDate;
            if (expiryDate <= today) {
                newExpiryDate = new Date(today);
                newExpiryDate.setDate(today.getDate() + extendDays);
            } else {
                newExpiryDate = new Date(expiryDate);
                newExpiryDate.setDate(expiryDate.getDate() + extendDays);
            }
            // Format date to YYYY-MM-DD
            const formattedDate = newExpiryDate.toISOString().split('T')[0];

            // store to state so UI shows it
            setExtendedDate(formattedDate);

            // Update ExpiryDays based on new date
            const diffTimeNew = newExpiryDate - today;
            const diffDaysNew = Math.ceil(diffTimeNew / (1000 * 60 * 60 * 24));
            let displayDaysNew;
            if (diffDaysNew < 0) {
                displayDaysNew = `-${Math.abs(diffDaysNew)}`;
            } else if (diffDaysNew === 0) {
                displayDaysNew = "0";
            } else {
                displayDaysNew = `${diffDaysNew}`;
            }
            setFormData((prev) => ({ ...prev, ExpiryDays: displayDaysNew }));

            // Validate required fields
            const missingFields = [];
            if (!formData.Id) missingFields.push("Id");
            if (!formData.ProductKey) missingFields.push("ProductKey");
            if (!formattedDate) missingFields.push("ExpiryDate");
            if (missingFields.length > 0) {
                console.log("Missing fields:", missingFields);
                setSnackbar({
                    open: true,
                    message: `Missing required fields: ${missingFields.join(", ")}`,
                    severity: "error"
                });
                return;
            }

            // Create payload for API call
            const payload = {
                Id: formData.Id,
                CustomerId: formData.CustomerId,
                ProductKey: formData.ProductKey,
                ExpiryDate: formattedDate,
                ExtendedDate: formattedDate,
                ExpiryDays: displayDaysNew
            };
            console.log(payload);
            try {
                const response = await axios.post(`${path}/api/members/extend`, payload);
                console.log("Extend key response:", response.data);
                setSnackbar({ open: true, message: "Key extended successfully", severity: "success" });
            } catch (error) {
                console.error("Error extending key:", error.response?.data || error.message);
                setSnackbar({ open: true, message: "Failed to extend key", severity: "error" });
            }
        } else {
            setSnackbar({ open: true, message: "Expiry Date is required", severity: "error" });
        }
    };

    // Handle Update Company dialog submission
    const handleUpdateCompanyDialogSubmit = async () => {
        // Log formData for debugging
        console.log("formData:", formData);

        // Validate Id
        if (!formData.Id) {
            setSnackbar({ open: true, message: "Record ID is missing", severity: "error" });
            return;
        }

        // Create payload for updating company data
        const payload = {
            Id: formData.Id,
            DistributorName: formData.DistributorName,
            CompanyName: formData.CompanyName,
            ItemCode: formData.ItemCode,
            ContactPerson: formData.ContactPerson,
            MobileNo: formData.MobileNo,
            EmailId: formData.EmailId,
            Website: formData.Website,
            Address1: formData.Address1,
            PinCode: formData.PinCode,
            Area: formData.Area,
            City: formData.City,
            State: formData.State,
            Country: formData.Country
        };

        // Log the payload
        console.log("Update company data payload:", payload);

        try {
            // Send payload to backend
            const response = await axios.post(`${path}/api/members/updateCompany`, payload);
            console.log("Update company data response:", response.data);
            setSnackbar({ open: true, message: "Company data updated successfully", severity: "success" });
            setOpenUpdateCompanyDialog(false);
            setSelectedRecord(null);
        } catch (error) {
            console.error("Error updating company data:", error.response?.data || error.message);
            setSnackbar({ open: true, message: "Failed to update company data", severity: "error" });
        }
    };

    // Handle dialog close
    const handleDialogClose = (dialogType) => {
        if (dialogType === "extend") {
            setOpenExtendDialog(false);
            setExtendedDate(""); // Reset extended date on close
        } else {
            setOpenUpdateCompanyDialog(false);
        }
        setSelectedRecord(null);
    };

    // Handle three-dot menu open
    const handleMenuOpen = (event, record) => {
        setAnchorEl(event.currentTarget);
        setMenuRecord(record);
    };

    // Handle three-dot menu close
    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuRecord(null);
    };

    // Determine warning icon based on expiry date
    const getWarningIcon = () => {
        if (!formData.ExpiryDate) return null;
        const expiryDate = new Date(formData.ExpiryDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expiryDate.setHours(0, 0, 0, 0);
        if (expiryDate < today) {
            return <WarningIcon sx={{ color: "#d32f2f" }} />;
        } else if (expiryDate.getTime() === today.getTime()) {
            return <WarningIcon sx={{ color: "#fbc02d" }} />;
        } else if (expiryDate > today) {
            return <CheckCircleIcon sx={{ color: "#4caf50" }} />;
        }
        return null;
    };

    // Add inside SearchForm component (with access to menuRecord, setAnchorEl, setSnackbar, setMenuRecord)
    const handleCancelWhatsapp = async (record) => {
        // close menu immediately
        setAnchorEl(null);
        setMenuRecord(null);

        if (!record) {
            setSnackbar({ open: true, message: "No record selected", severity: "error" });
            return;
        }

        // Try to read CustomerId with both casings
        const CustomerId = record.CustomerId ?? record.CustomerID ?? record.CustomerIdString ?? "";

        const payload = {
            Id: record.Id,
            CustomerId,         // may be empty string; backend will fetch if needed
            ProductKey: record.ProductKey,
            Deactivate: 1
        };

        try {
            const resp = await axios.post(`${path}/api/members/cancelWhatsapp`, payload);
            console.log("cancelWhatsapp resp:", resp.data);
            if (resp.data && resp.data.success) {
                // update searchResults: set WAKey to empty string for this record
                setSearchResults((prev) =>
                    prev.map((r) => {
                        // match by Id and ProductKey (both should uniquely identify)
                        if (r.Id === record.Id && (r.ProductKey ?? "") === (record.ProductKey ?? "")) {
                            return { ...r, WAKey: "", WAApplied: 0 };
                        }
                        return r;
                    })
                );

                // if the extend/update dialog is open for this record, update selectedRecord and formData too
                if (selectedRecord && selectedRecord.Id === record.Id && (selectedRecord.ProductKey ?? "") === (record.ProductKey ?? "")) {
                    setSelectedRecord((prev) => ({ ...prev, WAKey: "", WAApplied: 0 }));
                    setFormData((prev) => ({ ...prev, WAKey: "", WAApplied: 0 }));
                }

                setSnackbar({ open: true, message: resp.data.message || "WhatsApp cancelled", severity: "success" });
            } else {
                setSnackbar({ open: true, message: resp.data.message || "Failed to cancel WhatsApp", severity: "error" });
            }
        } catch (err) {
            console.error("cancelWhatsapp error:", err.response?.data || err.message);
            setSnackbar({ open: true, message: "Failed to cancel WhatsApp", severity: "error" });
        }
    };

    // Helper function to format date to dd-mm-yyyy
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <Box sx={{ pb: 2, px: { xs: 1, sm: 2, md: 3 } }}>
            <Box sx={{ mb: 2, position: "relative" }}>
                <Box sx={{ mb: 2 }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                        justifyContent: { xs: "flex-start", sm: "space-between" },
                        gap: { xs: 1, sm: 2 },
                        width: "100%",
                    }}>
                        {/* Left: Gen. New Key Button */}
                        <Button
                            variant="contained"
                            onClick={() => navigate("/main/generate-key", { state: { mode: "New" } })}
                            sx={{
                                height: { xs: 48, sm: 40 },
                                bgcolor: "#1877F2",
                                "&:hover": { bgcolor: "#145db5" },
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: "medium",
                                px: { xs: 1, sm: 2 },
                                fontSize: { xs: "0.9rem", sm: "1rem" },
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: { xs: "100%", sm: "auto" },
                            }}
                        >
                            <span style={{ display: "flex", alignItems: "center", gap: "8px", margin: "0 20px" }}>
                                New <VpnKeyRoundedIcon fontSize="small" />
                            </span>
                        </Button>
                        {/* Center: Search Form */}
                        <Box sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: 1, sm: 2 },
                            alignItems: { xs: "stretch", sm: "center" },
                            flexGrow: 1,
                            width: { xs: "100%", sm: "auto" },
                            maxWidth: { xs: "100%", sm: "600px", md: "800px", lg: "950px" },
                        }}>
                            <FormControl sx={{
                                width: { xs: "100%", sm: 200, md: 250 },
                                "& .MuiOutlinedInput-root": {
                                    height: { xs: 48, sm: 40 },
                                    borderRadius: 2,
                                    "& .MuiSelect-select": { display: "flex", alignItems: "center", height: "100%" },
                                    fontSize: { xs: "0.9rem", sm: "1rem" },
                                },
                            }}>
                                <InputLabel id="search-by-label" sx={{ fontSize: { xs: "0.9rem", sm: "0.85rem" } }}>
                                    Search By
                                </InputLabel>
                                <Select
                                    labelId="search-by-label"
                                    value={normalDropdown}
                                    label="Search By"
                                    onChange={(e) => setNormalDropdown(e.target.value)}
                                    sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
                                >
                                    <MenuItem value="CompanyName" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                                        Company Name
                                    </MenuItem>
                                    <MenuItem value="MobileNo" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                                        Mobile Number
                                    </MenuItem>
                                    <MenuItem value="ProductKey" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                                        Product Key
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                label="Search"
                                size="small"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                sx={{
                                    flexGrow: 1,
                                    "& .MuiInputBase-root": {
                                        height: { xs: 48, sm: 40 },
                                        borderRadius: 2,
                                        backgroundColor: "#F5F7FA",
                                        "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" } },
                                        fontSize: { xs: "0.9rem", sm: "1rem" },
                                    },
                                    "& .MuiInputLabel-root": {
                                        fontSize: { xs: "0.9rem", sm: "0.85rem" },
                                        color: "#555",
                                        "&.Mui-focused": { color: "#1976D2" },
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
                                }}
                            />
                        </Box>
                        {/* Right: Upload and Insert Data Buttons */}
                        <Box sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: 1, sm: 2 },
                            width: { xs: "100%", sm: "auto" },
                        }}>
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={() => navigate("/main/FileUpload")}
                                sx={{
                                    height: { xs: 48, sm: 40 },
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: "medium",
                                    fontSize: { xs: "0.9rem", sm: "1rem" },
                                    px: { xs: 1, sm: 2 },
                                    width: { xs: "100%", sm: "auto" },
                                }}
                            >
                                <DriveFolderUploadIcon fontSize="small" />
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => navigate("/main/InsertData")}
                                sx={{
                                    height: { xs: 48, sm: 40 },
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: "medium",
                                    fontSize: { xs: "0.9rem", sm: "1rem" },
                                    px: { xs: 1, sm: 2 },
                                    width: { xs: "100%", sm: "auto" },
                                }}
                            >
                                <InsertDriveFileIcon fontSize="small" />
                            </Button>
                        </Box>
                    </Box>
                </Box>
                {/* Search results dropdown */}
                {showResults && searchText && (
                    <Paper sx={{
                        position: "absolute",
                        mt: 0,
                        maxHeight: { xs: "70vh", sm: "75vh", md: "82vh" },
                        overflowY: "auto",
                        zIndex: 10,
                        borderRadius: 2,
                        border: "1px solid #e0e0e0",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                        backgroundColor: "#fff",
                        transition: "transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out",
                        width: { xs: "100%", sm: "95%", md: "90%", lg: "calc(100% - 48px)" },
                        maxWidth: { xs: "100%", sm: "600px", md: "800px", lg: "950px" },
                        mx: "auto",
                    }}>
                        {searchResults.length ? (
                            searchResults.map((r, index) => (
                                <Box
                                    key={r.CustomerID}
                                    ref={index === searchResults.length - 1 ? lastRecordElementRef : null}
                                    sx={{
                                        m: { xs: 0.5, sm: 1 },
                                        p: { xs: 1, sm: 1.5 },
                                        borderRadius: 2,
                                        border: "1px solid #e0e0e0",
                                        backgroundColor: index % 2 === 0 ? "#ffffff" : "#f0f6ff",
                                        transition: "transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out",
                                        position: "relative",
                                        "&:hover": {
                                            transform: "scale(1.001)",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                            backgroundColor: index % 2 === 0 ? "#f8fafc" : "#e6f0ff",
                                        },
                                    }}
                                >
                                    <IconButton
                                        onClick={(e) => handleMenuOpen(e, r)}
                                        sx={{
                                            position: "absolute",
                                            top: { xs: 4, sm: 8 },
                                            right: { xs: 4, sm: 8 },
                                            color: "#666",
                                            "&:hover": { color: "#1976D2" },
                                            p: { xs: 0.5, sm: 1 },
                                        }}
                                    >
                                        <MoreVertIcon fontSize="small" />
                                    </IconButton>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 0.5, sm: 1 } }}>
                                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography
                                                variant="h6"
                                                fontWeight="600"
                                                color="#1976D2"
                                                sx={{ fontSize: { xs: "0.9rem", sm: "1rem" }, lineHeight: 1 }}
                                            >
                                                {r.CompanyName || "N/A"}
                                            </Typography>
                                        </Box>
                                        <Box sx={{
                                            display: "grid",
                                            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                                            gap: { xs: 0.3, sm: 0.5 },
                                        }}>
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                                <strong>Product Key:</strong> {r.ProductKey || "N/A"}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                                <strong>Contact Person:</strong> {r.ContactPerson || "N/A"}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                                <strong>Mobile Number:</strong> {r.MobileNo || "N/A"}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                                <strong>Email:</strong> {r.EmailId || "N/A"}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                                <strong>Location:</strong> {r.City || "N/A"}, {r.State || "N/A"}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                                <strong>WAKey:</strong> {(r.WAKey === null || typeof r.WAKey === "undefined") ? "-" : r.WAKey}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            ))
                        ) : (
                            <Typography sx={{ p: 2, textAlign: "center", color: "#666", fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>
                                No Data Available
                            </Typography>
                        )}
                    </Paper>
                )}
            </Box>

            {/* Three-dot menu */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: 2,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        minWidth: { xs: 160, sm: 180 },
                    },
                }}
            >
                <MenuItem onClick={() => handleUpdateClick(menuRecord)} sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>
                    Update
                </MenuItem>
                <MenuItem onClick={() => handleExtendClick(menuRecord)} sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>
                    Extend
                </MenuItem>
                <MenuItem onClick={() => handleUpdateCompanyClick(menuRecord)} sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>
                    Update Company Data
                </MenuItem>
                <MenuItem onClick={() => handleCancelWhatsapp(menuRecord)} sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>
                    Cancel WhatsApp
                </MenuItem>
            </Menu>

            {/* Dialog for Extend mode */}
            <Dialog
                open={openExtendDialog}
                onClose={() => handleDialogClose("extend")}
                maxWidth="md"
                fullWidth
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: 3,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                        backgroundColor: "#f9fafb",
                        p: { xs: 1, sm: 2 },
                        maxHeight: { xs: "90vh", sm: "80vh" },
                        overflowY: "auto",
                        width: { xs: "95%", sm: "90%", md: "80%" },
                        mx: "auto",
                    },
                }}
            >
                <DialogTitle sx={{
                    fontWeight: 600,
                    fontSize: { xs: "1.2rem", sm: "1.5rem" },
                    color: "#1976D2",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pb: 1,
                    borderBottom: "1px solid #e0e0e0",
                }}>
                    Extend Key
                    <Button
                        onClick={() => handleDialogClose("extend")}
                        sx={{ minWidth: 0, p: { xs: 0.3, sm: 0.5 }, color: "#666", "&:hover": { color: "#d32f2f" } }}
                    >
                        <CancelIcon fontSize="small" />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{ p: { xs: 1, sm: 3 } }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 0.5, sm: 1 }, mt: { xs: 1, sm: 2 } }}>
                        <Typography
                            variant="h6"
                            fontWeight="600"
                            color="#1976D2"
                            sx={{ fontSize: { xs: "0.9rem", sm: "1rem" }, lineHeight: 1 }}
                        >
                            {formData.CompanyName || "N/A"}
                        </Typography>
                        <Box sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                            gap: { xs: 0.3, sm: 0.5 },
                        }}>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Contact Person:</strong> {formData.ContactPerson || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Mobile Number:</strong> {formData.MobileNo || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Email:</strong> {formData.EmailId || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Website:</strong> {formData.Website || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Address:</strong> {formData.Address1 || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Pin Code:</strong> {formData.PinCode || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Area:</strong> {formData.Area || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>City:</strong> {formData.City || "N/A"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>State:</strong> {formData.State || "N/A"}
                            </Typography>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                    <strong>Country:</strong> {formData.Country || "N/A"}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" }, gap: { xs: 1, sm: 2 }, mt: 1 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                                <strong>Expiry Date:</strong> {formatDate(formData.ExpiryDate)}
                            </Typography>
                            <TextField
                                label="Extend by (days)"
                                type="number"
                                value={extendDays}
                                onChange={(e) => setExtendDays(Math.max(1, parseInt(e.target.value) || 2))}
                                inputProps={{ min: 1, step: 1 }}
                                size="small"
                                sx={{
                                    width: { xs: "100%", sm: 120 },
                                    "& .MuiInputBase-root": { height: { xs: 40, sm: 36 }, fontSize: { xs: "0.8rem", sm: "0.9rem" } },
                                }}
                            />
                            {formData.ExpiryDate && (() => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const expiry = new Date(formData.ExpiryDate);
                                expiry.setHours(0, 0, 0, 0);
                                const diffTime = expiry - today;
                                const daysToExpiry = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                return daysToExpiry <= 7 ? (
                                    <Button
                                        variant="contained"
                                        onClick={handleExtendDialogSubmit}
                                        disabled={!!extendedDate}
                                        sx={{
                                            height: { xs: 40, sm: 36 },
                                            bgcolor: "#1976D2",
                                            "&:hover": { bgcolor: "#115293" },
                                            borderRadius: 2,
                                            textTransform: "none",
                                            fontWeight: "medium",
                                            px: { xs: 1, sm: 2 },
                                            fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                            width: { xs: "100%", sm: "auto" },
                                            "&.Mui-disabled": { bgcolor: "#bdbdbd", cursor: "not-allowed", color: "#666" },
                                        }}
                                    >
                                        Extend
                                    </Button>
                                ) : null;
                            })()}
                            {getWarningIcon()}
                            {extendedDate && (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" }, mt: { xs: 1, sm: 0 } }}
                                >
                                    <strong>Extended Date:</strong> {extendedDate}
                                </Typography>
                            )}
                        </Box>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}>
                            <strong>Expiry Days:</strong> {formData.ExpiryDays || "0"}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{
                    p: { xs: 1, sm: 2 },
                    borderTop: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    borderRadius: "0 0 12px 12px",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                }}>
                    <Button
                        onClick={() => handleDialogClose("extend")}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: "medium",
                            color: "#666",
                            borderColor: "#e0e0e0",
                            "&:hover": { borderColor: "#d32f2f", color: "#d32f2f" },
                            fontSize: { xs: "0.8rem", sm: "0.9rem" },
                            px: { xs: 1, sm: 2 },
                            height: { xs: 40, sm: 36 },
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog for Update Company Data mode */}
            <Dialog
                open={openUpdateCompanyDialog}
                onClose={() => handleDialogClose("updateCompany")}
                maxWidth="md"
                fullWidth
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: 3,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                        backgroundColor: "#f9fafb",
                        p: { xs: 1, sm: 2 },
                        maxHeight: { xs: "90vh", sm: "80vh" },
                        overflowY: "auto",
                        width: { xs: "95%", sm: "90%", md: "80%" },
                        mx: "auto",
                    },
                }}
            >
                <DialogTitle sx={{
                    fontWeight: 600,
                    fontSize: { xs: "1.2rem", sm: "1.5rem" },
                    color: "#1976D2",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pb: 1,
                    borderBottom: "1px solid #e0e0e0",
                }}>
                    Update Company Data
                    <Button
                        onClick={() => handleDialogClose("updateCompany")}
                        sx={{ minWidth: 0, p: { xs: 0.3, sm: 0.5 }, color: "#666", "&:hover": { color: "#d32f2f" } }}
                    >
                        <CancelIcon fontSize="small" />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{ p: { xs: 1, sm: 3 } }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: { xs: 1, sm: 2 }, mt: { xs: 1, sm: 2 } }}>
                        {/* DistributorName full width */}
                        <TextField
                            key="DistributorName"
                            label="Distributor Name"
                            value={formData["DistributorName"] || ""}
                            onChange={(e) => handleFormChange("DistributorName", e.target.value)}
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{
                                "& .MuiInputBase-root": {
                                    height: { xs: 40, sm: 36 },
                                    borderRadius: 2,
                                    backgroundColor: "#fff",
                                    "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" } },
                                    fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontSize: { xs: "0.8rem", sm: "0.85rem" },
                                    color: "#555",
                                    "&.Mui-focused": { color: "#1976D2" },
                                },
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
                            }}
                        />

                        {/* Two-column grid */}
                        <Box sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                            gap: { xs: 1, sm: 2 },
                        }}>
                            {/* Left column */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1, sm: 2 } }}>
                                {["CompanyName", "ContactPerson", "EmailId", "Address1", "Area", "State"].map(
                                    (field) => (
                                        <TextField
                                            key={field}
                                            label={field.replace(/([A-Z])/g, " $1").trim()}
                                            value={formData[field] || ""}
                                            onChange={(e) => handleFormChange(field, e.target.value)}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: { xs: 40, sm: 36 },
                                                    borderRadius: 2,
                                                    backgroundColor: "#fff",
                                                    "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" } },
                                                    fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                                },
                                                "& .MuiInputLabel-root": {
                                                    fontSize: { xs: "0.8rem", sm: "0.85rem" },
                                                    color: "#555",
                                                    "&.Mui-focused": { color: "#1976D2" },
                                                },
                                                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
                                            }}
                                        />
                                    )
                                )}
                            </Box>

                            {/* Right column */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1, sm: 2 } }}>
                                {["ItemCode", "MobileNo", "Website", "PinCode", "City", "Country"].map(
                                    (field) => (
                                        <TextField
                                            key={field}
                                            label={field.replace(/([A-Z])/g, " $1").trim()}
                                            value={formData[field] || ""}
                                            onChange={(e) => handleFormChange(field, e.target.value)}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: { xs: 40, sm: 36 },
                                                    borderRadius: 2,
                                                    backgroundColor: "#fff",
                                                    "&:hover": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" } },
                                                    fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                                },
                                                "& .MuiInputLabel-root": {
                                                    fontSize: { xs: "0.8rem", sm: "0.85rem" },
                                                    color: "#555",
                                                    "&.Mui-focused": { color: "#1976D2" },
                                                },
                                                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
                                            }}
                                        />
                                    )
                                )}
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{
                    p: { xs: 1, sm: 2 },
                    borderTop: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    borderRadius: "0 0 12px 12px",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                }}>
                    <Button
                        onClick={() => handleDialogClose("updateCompany")}
                        color="error"
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: "medium",
                            borderColor: "#e0e0e0",
                            "&:hover": { borderColor: "#d32f2f" },
                            fontSize: { xs: "0.8rem", sm: "0.9rem" },
                            px: { xs: 1, sm: 2 },
                            height: { xs: 40, sm: 36 },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleUpdateCompanyDialogSubmit}
                        variant="contained"
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: "medium",
                            bgcolor: "#1976D2",
                            "&:hover": { bgcolor: "#115293" },
                            px: { xs: 1, sm: 3 },
                            fontSize: { xs: "0.8rem", sm: "0.9rem" },
                            height: { xs: 40, sm: 36 },
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Snackbar for feedback */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%', fontSize: { xs: "0.8rem", sm: "0.9rem" } }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

const KeyOptions = () => {
    return (
        <Container sx={{ pt: { xs: 2, sm: 3 }, px: { xs: 1, sm: 2, md: 3 } }}>
            <SearchForm mode="update" />
        </Container>
    );
};

export default KeyOptions;